








































































import store from '@/store/store'
import { Component, Vue } from 'vue-property-decorator'
import ButtonComponent from '../buttons/ButtonComponent.vue'
import LogService from '@/api/broadcast/LogService'

@Component({
  components: {
    PageHeaderComponent: () => import('../PageHeaderComponent.vue'),
    ButtonComponent
  }
})

export default class AeroguestSupportComponent extends Vue {
  public navigateToSupportSheet () {
    this.$emit('opensupport')
  }

  public closeTheComponent () {
    store.removeLocalstorage('AGSUPPORTDATA')
    this.$emit('close')
  }

  public async downloadApp () {
    this.$emit('skip')
  }

  public goToFAQ () {
    LogService.LogInformation('Support - clicked on go to FAQ', {})
    window.open('https://faq.aeroguest.com', '_blank')
  }

  public goToTermsOfService () {
    LogService.LogInformation('Support - clicked on go to Terms of Service', {})
    window.open('https://faq.aeroguest.com/terms-of-service', '_blank')
  }

  public goToPrivacyPolicy () {
    LogService.LogInformation('Support - clicked on go to Privacy Policy', {})
    window.open('https://faq.aeroguest.com/privacy-policy', '_blank')
  }
}
